import React from "react";

import bannerPopupActions from "../../redux/bannerPopup/action";
import "./style.css";
import { connect } from "react-redux";

const InfoBanner = (props) => {
  if (!props.banner.visible) return null;

  const onClose = () => {
    props.removeBannerPopup();
  };

  return (
    <div className="infoBanner_container">
      <div className="infoBanner_boxContainer">
        <div className="infoBanner_headerContainer">
          <p className="infoBanner_headerTitle">
            {props.banner.title || "Message"}
          </p>
          <img
            onClick={onClose}
            className="infoBanner_closeIcon"
            src={require("../../assets/icons/close-white.png")}
          />
        </div>
        <div className="infoBanner_contentContainer">
          {typeof props.banner.message === "string" ? (
            <p className="infoBanner_bodyText">{props.banner.message}</p>
          ) : (
            props.banner.message.map((item, index) => {
              return (
                <p key={index} className="infoBanner_bodyText">
                  {item}
                </p>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (store) => ({
  banner: store.bannerPopup.banner,
});

const mapDispatchToProps = {
  removeBannerPopup: bannerPopupActions.removeBannerPopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(InfoBanner);
